import { render, staticRenderFns } from "./LaboratoriesListSearch.vue?vue&type=template&id=2eaa2878&"
import script from "./LaboratoriesListSearch.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LaboratoriesListSearch.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eaa2878')) {
      api.createRecord('2eaa2878', component.options)
    } else {
      api.reload('2eaa2878', component.options)
    }
    module.hot.accept("./LaboratoriesListSearch.vue?vue&type=template&id=2eaa2878&", function () {
      api.rerender('2eaa2878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/components/LaboratoriesList/components/LaboratoriesListSearch.vue"
export default component.exports